*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-block;
  line-height: 0;
}

.avatar-inner {
  position: relative;

  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: calc(infinity * 1px);

  background-color: rgb(229 229 229 / 0.6);
}

:host([shape='square']) .avatar-inner {
  border-radius: 12px;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-fallback {
  position: absolute;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
}

slot {
  position: absolute;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  line-height: 1;
}

.avatar-initials {
  user-select: none;

  font-size: calc(var(--wui-avatar-size, 40px) * 0.4);
  font-weight: 500;
  line-height: 1;
  color: rgb(27 27 27 / 0.7);
}
